module.exports = __webpack_public_path__ + "img/yishi6.60c5d90d.jpg";